<template>
<input class="btn btn-state" />
</template>

<script>
export default {
    
}
</script>